import { render, staticRenderFns } from "./IndicesByInvesting.vue?vue&type=template&id=3a1d0b62&"
import script from "./IndicesByInvesting.vue?vue&type=script&lang=js&"
export * from "./IndicesByInvesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports